import { useFormik } from 'formik';
import Link from 'next/link';
import { useState } from 'react';
import styled from 'styled-components';
import Swal from 'sweetalert2';
import * as Yup from 'yup';
import AlertManager from '../../../../../shared/components/global/AlertManager';
import { Button } from '../../../../../shared/styles/button';
import { CheckboxContainer, Container, ContainerContentStandard } from '../../../../../shared/styles/container';
import { Headline, SubHeadline } from '../../../../../shared/styles/headline';
import { Checkbox, Input, Select, Textarea } from '../../../../../shared/styles/input';

const InputRowSingle = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  width: 100%;
  margin-bottom: 1rem;
`;
const ACForm = styled.form`
    max-width: 650px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 64px;

    label {
        text-align: left;
    }
`;

export const ActiveCampaignForm = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [formSubmitted, setFormSubmitted] = useState(false)

    const formik = useFormik({
        initialValues: {
            anrede: '',
            lastname: '',
            firstname: '',
            agentur: '',
            anfrage: '',
            checkbox: false,
            phone: '',
            email: '',
        },
        validationSchema: Yup.object({
            lastname: Yup.string()
                .required('Pflichtfeld.'),
            firstname: Yup.string()
                .required('Pflichtfeld.'),
            agentur: Yup.string()
                .required('Pflichtfeld.'),
            anfrage: Yup.string()
                .max(1000),
            checkbox: Yup.string()
                .required('Pflichtfeld.'),
            phone: Yup.string()
                .required('Pflichtfeld.'),
            email: Yup.string()
                .email()
                .required('Pflichtfeld.'),
        }),

        onSubmit: (values: any) => {
            setLoading(true)
            let formData: FormData = new FormData();

            formData.append("u", "236");
            formData.append("f", "236");
            formData.append("s", "");
            formData.append("c", "0");
            formData.append("m", "0");
            formData.append("act", "sub");
            formData.append("v", "2");
            formData.append("or", "877822fd96581e89dc86706d50f8f873");
            formData.append("jsonp", "true");
            /*
                        https://scmonline.activehosted.com/proc.php?u=618E92E2E894F&f=236&s=&c=0&m=0&act=sub&v=2&or=a992377d9a6010014f04c9b152aede2b&lastname=Meise&firstname=Christoph&field[133]=asdasd&phone=%2B4915224054008&email=projects%40explorechristoph.com&field[146]=sdasd&field[145][]=~%7C&field[145][]=Hiermit%20best%C3%A4tige%20ich%2C%20dass%20ich%20die%20Datenschutzerkl%C3%A4rung%20zur%20Kenntnis%20genommen%20habe.%20Die%20Verarbeitung%20meiner%20personenbezogenen%20Daten%20kann%20ich%20jederzeit%20widerrufen.*&jsonp=true
            
    <input type="hidden" name="u" value="236" />
    <input type="hidden" name="f" value="236" />
    <input type="hidden" name="s" />
    <input type="hidden" name="c" value="0" />
    <input type="hidden" name="m" value="0" />
    <input type="hidden" name="act" value="sub" />
    <input type="hidden" name="v" value="2" />
    <input type="hidden" name="or" value="f40f79c5dc5b425d1646bbf616bab0d2" />
                        */
            for (var key in values) {
                let acKey = key;
                if (key === 'agentur') {
                    acKey = "field[133]";
                } else if (key === 'anfrage') {
                    acKey = "field[146]";
                } else if (key === 'anrede') {
                    acKey = "field[115]";
                } else if (key === 'checkbox') {
                    acKey = "field[145][]";
                    formData.append(acKey, "~|");
                    formData.append(acKey, "Hiermit bestätige ich, dass ich die Datenschutzerklärung zur Kenntnis genommen habe. Die Verarbeitung meiner personenbezogenen Daten kann ich jederzeit widerrufen.*");
                    continue;
                }
                formData.append(acKey, values[key]);
            }

            fetch("https://scmonline.activehosted.com/proc.php", {
                method: "POST",
                body: formData,
                mode: "no-cors",
            })
                .then(() => {
                    setLoading(false);
                    setFormSubmitted(true);
                    setTimeout(() => {
                        setFormSubmitted(false);
                    }, 5000);
                    formik.resetForm();
                    Swal.fire(AlertManager.ActiveCampaignMessageSuccess());
                })
                .catch(error => {
                    setLoading(false);
                    Swal.fire(AlertManager.ActiveCampaignMessageError(error, formData));
                    console.error("Request failed", error);
                });
        },
    });

    return (
        <Container centered id="contact">
            <ContainerContentStandard>
                <Headline>Jetzt unverbindlich anfragen</Headline>
                <SubHeadline>Optimiere dein Recruiting über die Bewerberakquise beim STELL-MICH-EIN-Talentpool:</SubHeadline>
                {/* <div className="_form_236"></div><script src="https://scmonline.activehosted.com/f/embed.php?id=236" type="text/javascript" charSet="utf-8"></script> */}
                <ACForm onSubmit={formik.handleSubmit}>
                    <InputRowSingle>
                        <Select
                            id="anrede"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            name="anrede"
                            value={formik.values.anrede}
                            error={formik.touched.anrede && formik.errors.anrede != null}
                        >
                            <option value="">--Anrede wählen--</option>
                            <option value="Herr">Herr</option>
                            <option value="Frau">Frau</option>
                        </Select>
                    </InputRowSingle>
                    <InputRowSingle>
                        <Input
                            id="firstname"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Vorname"
                            name="firstname"
                            type="text"
                            value={formik.values.firstname}
                            error={formik.touched.firstname && formik.errors.firstname != null}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <Input
                            id="lastname"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Nachname"
                            name="lastname"
                            type="text"
                            value={formik.values.lastname}
                            error={formik.touched.lastname && formik.errors.lastname != null}
                        />

                    </InputRowSingle>
                    <InputRowSingle>
                        <Input
                            id="agentur"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Agenturname"
                            name="agentur"
                            type="text"
                            value={formik.values.agentur}
                            error={formik.touched.agentur && formik.errors.agentur != null}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <Input
                            id="phone"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Telefonnummer"
                            name="phone"
                            type="text"
                            value={formik.values.phone}
                            error={formik.touched.phone && formik.errors.phone != null}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <Input
                            id="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="E-Mail Adresse"
                            name="email"
                            type="text"
                            value={formik.values.email}
                            error={formik.touched.email && formik.errors.email != null}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <Textarea
                            id="anfrage"
                            name="anfrage"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder="Tippe deine Anfrage ein. Z.B. Ich habe Interesse an einer Live-Demo. Bitte kontaktiert mich mit weiteren Infos."
                            value={formik.values.anfrage}
                            error={formik.touched.anfrage && formik.errors.anfrage != null}
                            rows={8}
                        />
                    </InputRowSingle>
                    <InputRowSingle>
                        <CheckboxContainer>
                            <Checkbox
                                id="checkbox"
                                name="checkbox"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                type="checkbox"
                                checked={formik.values.checkbox}
                                error={formik.touched.checkbox && formik.errors.checkbox != null}
                            />
                            <label htmlFor="checkbox">Ich bin damit einverstanden, per E-Mail und telefonisch Informationen zum SME-Talentpool bis auf Widerruf zu erhalten. Die <Link href="/datenschutz">Datenschutzhinweise</Link> habe ich zur Kenntnis genommen.</label>
                        </CheckboxContainer>
                    </InputRowSingle>
                    <InputRowSingle>
                        <Button disabled={loading || !formik.isValid || !formik.values.checkbox} $loading={loading} primary type="submit">
                            Abschicken
                        </Button>
                    </InputRowSingle>
                </ACForm>
            </ContainerContentStandard >
        </Container>
    );

}
